"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const API = {
    list: `/api/ac/v2/company/published/list`,
    listUserCompanies: `/api/console/billing/company/list`,
    create: `/api/console/company/create`,
    update: `/api/console/company/update`,
    attachPaymentMethod: `/api/console/company/payment/attach`,
    detachPaymentMethod: `/api/console/company/payment/detach`,
};
class Company {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getListCompanies() {
        const res = await this._httpClient.get(API.list);
        const data = {
            result: null,
            entities: {},
        };
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async getListUserCompanies(page, limit, clientId) {
        const res = await this._httpClient.get(API.listUserCompanies, {
            params: { page, limit, clientId },
        });
        const data = {
            result: null,
            paging: {
                total: 0,
                page,
                limit,
            },
            entities: {},
        };
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.paging = resBody.paging;
        data.entities = resBody.entities;
        return data;
    }
    async createCompany(payload) {
        const res = await this._httpClient.post(API.create, payload);
        const resBody = lodash_1.default.get(res, 'data.data', {});
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async updateCompany(payload) {
        const res = await this._httpClient.put(`${API.update}`, payload);
        const resBody = lodash_1.default.get(res, 'data.data', {});
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async attachPaymentMethod(companyId, paymentMethod, clientId) {
        const res = await this._httpClient.post(API.attachPaymentMethod, {
            companyId,
            paymentMethod,
            clientId,
        });
        const resBody = lodash_1.default.get(res, 'data.data', {});
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    async detachPaymentMethod(companyId, paymentMethodId, clientId) {
        const res = await this._httpClient.post(API.detachPaymentMethod, {
            companyId,
            paymentMethodId,
            clientId,
        });
        const resBody = lodash_1.default.get(res, 'data.data', {});
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
}
exports.default = Company;
